/* ==========================================================================
  main.js
========================================================================== */

// responsive videos
fitvids();


// add jquery as dependency in functions.php and uncomment the following if you need jquery
(function($) {

  if (typeof objectFitImages === "function") {
    objectFitImages();
  }

  $(document).ready(function(){

   // mobile menu
    $('#side-menu').aucor_side_navigation({
      menu_toggle: "#menu-toggle", // selector for toggle
      menu_items: sol_menu
    });

    // side menu close
    $('#side-menu-toggle').click(function() {
      $('#menu-toggle').click();
    });

    // header search
    $('.primary-navigation__search').click(function() {
      $('#masthead').toggleClass('site-header--search-open');
      if ($('#masthead').hasClass('site-header--search-open')) {
        $('#header-search-input').focus();
      }
    });

    // Sidebar navigation functionality
    $('.sub-pages-navigation button').click(function() {
      var $li = $(this).parents('li');
      if ($li.hasClass('hidden') && ($li.hasClass('current_page_item') || $li.hasClass('current_page_ancestor') )) {
        $li.addClass('open');
        $li.removeClass('hidden');
      } else if($li.hasClass('current_page_item') || $li.hasClass('current_page_ancestor') ) {
        $li.addClass('hidden');
        $li.removeClass('open');
      } else {
        $li.removeClass('hidden');
        $li.toggleClass('open');
      }
      //$(this).blur();
    });

    // terms of services on jobs
    $('#sol-terms-of-service').change(function() {
      if (this.checked) {
        $('#job-cta-link').removeClass('button--disabled');
      } else {
        $('#job-cta-link').addClass('button--disabled');
      }
    });



    // fix pretend id parents
    $('.pretend_current_page_item').parents('li').addClass('current_page_ancestor').addClass('current_page_parent');


  });
})(jQuery);

